/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getNewsletterChangeSettings } from '../fn/profile-newsletter/get-newsletter-change-settings';
import { GetNewsletterChangeSettings$Params } from '../fn/profile-newsletter/get-newsletter-change-settings';
import { nextNewsletterInfo } from '../fn/profile-newsletter/next-newsletter-info';
import { NextNewsletterInfo$Params } from '../fn/profile-newsletter/next-newsletter-info';
import { profileNewsletterChangeSettings } from '../fn/profile-newsletter/profile-newsletter-change-settings';
import { ProfileNewsletterChangeSettings$Params } from '../fn/profile-newsletter/profile-newsletter-change-settings';
import { ProfileNewsletterContact } from '../models/profile-newsletter-contact';
import { profileNewsletterCreateContact } from '../fn/profile-newsletter/profile-newsletter-create-contact';
import { ProfileNewsletterCreateContact$Params } from '../fn/profile-newsletter/profile-newsletter-create-contact';
import { profileNewsletterDeleteContact } from '../fn/profile-newsletter/profile-newsletter-delete-contact';
import { ProfileNewsletterDeleteContact$Params } from '../fn/profile-newsletter/profile-newsletter-delete-contact';
import { profileNewsletterImport } from '../fn/profile-newsletter/profile-newsletter-import';
import { ProfileNewsletterImport$Params } from '../fn/profile-newsletter/profile-newsletter-import';
import { ProfileNewsletterImportResponse } from '../models/profile-newsletter-import-response';
import { profileNewsletterListContact } from '../fn/profile-newsletter/profile-newsletter-list-contact';
import { ProfileNewsletterListContact$Params } from '../fn/profile-newsletter/profile-newsletter-list-contact';
import { ProfileNewsletterListContactsResponse } from '../models/profile-newsletter-list-contacts-response';
import { ProfileNewsletterNextInfo } from '../models/profile-newsletter-next-info';
import { profileNewsletterPatchContact } from '../fn/profile-newsletter/profile-newsletter-patch-contact';
import { ProfileNewsletterPatchContact$Params } from '../fn/profile-newsletter/profile-newsletter-patch-contact';
import { ProfileNewsletterSettings } from '../models/profile-newsletter-settings';
import { profileNewsletterTestImport } from '../fn/profile-newsletter/profile-newsletter-test-import';
import { ProfileNewsletterTestImport$Params } from '../fn/profile-newsletter/profile-newsletter-test-import';
import { profileNewsletterTestSend } from '../fn/profile-newsletter/profile-newsletter-test-send';
import { ProfileNewsletterTestSend$Params } from '../fn/profile-newsletter/profile-newsletter-test-send';

@Injectable({ providedIn: 'root' })
export class ProfileNewsletterService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `profileNewsletterTestImport()` */
  static readonly ProfileNewsletterTestImportPath = '/rest/profile/{id}/newsletter/test-import';

  /**
   * Test import of newsletter contacts - no contacts are deleted or saved.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileNewsletterTestImport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileNewsletterTestImport$Response(params: ProfileNewsletterTestImport$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterImportResponse>> {
    return profileNewsletterTestImport(this.http, this.rootUrl, params, context);
  }

  /**
   * Test import of newsletter contacts - no contacts are deleted or saved.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileNewsletterTestImport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileNewsletterTestImport(params: ProfileNewsletterTestImport$Params, context?: HttpContext): Observable<ProfileNewsletterImportResponse> {
    return this.profileNewsletterTestImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileNewsletterImportResponse>): ProfileNewsletterImportResponse => r.body)
    );
  }

  /** Path part for operation `profileNewsletterImport()` */
  static readonly ProfileNewsletterImportPath = '/rest/profile/{id}/newsletter/import';

  /**
   * Import of newsletter contacts - old contacs are deleted and new are saved.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileNewsletterImport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileNewsletterImport$Response(params: ProfileNewsletterImport$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterImportResponse>> {
    return profileNewsletterImport(this.http, this.rootUrl, params, context);
  }

  /**
   * Import of newsletter contacts - old contacs are deleted and new are saved.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileNewsletterImport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileNewsletterImport(params: ProfileNewsletterImport$Params, context?: HttpContext): Observable<ProfileNewsletterImportResponse> {
    return this.profileNewsletterImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileNewsletterImportResponse>): ProfileNewsletterImportResponse => r.body)
    );
  }

  /** Path part for operation `profileNewsletterListContact()` */
  static readonly ProfileNewsletterListContactPath = '/rest/profile/{id}/newsletter/contact';

  /**
   * Lis of all profile newsletter contancts with paging / sorting / filtering.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileNewsletterListContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileNewsletterListContact$Response(params: ProfileNewsletterListContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterListContactsResponse>> {
    return profileNewsletterListContact(this.http, this.rootUrl, params, context);
  }

  /**
   * Lis of all profile newsletter contancts with paging / sorting / filtering.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileNewsletterListContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileNewsletterListContact(params: ProfileNewsletterListContact$Params, context?: HttpContext): Observable<ProfileNewsletterListContactsResponse> {
    return this.profileNewsletterListContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileNewsletterListContactsResponse>): ProfileNewsletterListContactsResponse => r.body)
    );
  }

  /** Path part for operation `profileNewsletterCreateContact()` */
  static readonly ProfileNewsletterCreateContactPath = '/rest/profile/{id}/newsletter/contact';

  /**
   * Create new profile newletter post.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileNewsletterCreateContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileNewsletterCreateContact$Response(params: ProfileNewsletterCreateContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterContact>> {
    return profileNewsletterCreateContact(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new profile newletter post.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileNewsletterCreateContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileNewsletterCreateContact(params: ProfileNewsletterCreateContact$Params, context?: HttpContext): Observable<ProfileNewsletterContact> {
    return this.profileNewsletterCreateContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileNewsletterContact>): ProfileNewsletterContact => r.body)
    );
  }

  /** Path part for operation `profileNewsletterDeleteContact()` */
  static readonly ProfileNewsletterDeleteContactPath = '/rest/profile/{id}/newsletter/contact/{email}';

  /**
   * Delete existing profile newsletter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileNewsletterDeleteContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileNewsletterDeleteContact$Response(params: ProfileNewsletterDeleteContact$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return profileNewsletterDeleteContact(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete existing profile newsletter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileNewsletterDeleteContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileNewsletterDeleteContact(params: ProfileNewsletterDeleteContact$Params, context?: HttpContext): Observable<void> {
    return this.profileNewsletterDeleteContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `profileNewsletterPatchContact()` */
  static readonly ProfileNewsletterPatchContactPath = '/rest/profile/{id}/newsletter/contact/{email}';

  /**
   * Patch (update) existing profile newletter post.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileNewsletterPatchContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileNewsletterPatchContact$Response(params: ProfileNewsletterPatchContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterContact>> {
    return profileNewsletterPatchContact(this.http, this.rootUrl, params, context);
  }

  /**
   * Patch (update) existing profile newletter post.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileNewsletterPatchContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileNewsletterPatchContact(params: ProfileNewsletterPatchContact$Params, context?: HttpContext): Observable<ProfileNewsletterContact> {
    return this.profileNewsletterPatchContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileNewsletterContact>): ProfileNewsletterContact => r.body)
    );
  }

  /** Path part for operation `getNewsletterChangeSettings()` */
  static readonly GetNewsletterChangeSettingsPath = '/rest/profile/{id}/newsletter/settings';

  /**
   * Get profile newsletter settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNewsletterChangeSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNewsletterChangeSettings$Response(params: GetNewsletterChangeSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterSettings>> {
    return getNewsletterChangeSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Get profile newsletter settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNewsletterChangeSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNewsletterChangeSettings(params: GetNewsletterChangeSettings$Params, context?: HttpContext): Observable<ProfileNewsletterSettings> {
    return this.getNewsletterChangeSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileNewsletterSettings>): ProfileNewsletterSettings => r.body)
    );
  }

  /** Path part for operation `profileNewsletterChangeSettings()` */
  static readonly ProfileNewsletterChangeSettingsPath = '/rest/profile/{id}/newsletter/settings';

  /**
   * Change profile newsletter settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileNewsletterChangeSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileNewsletterChangeSettings$Response(params: ProfileNewsletterChangeSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterSettings>> {
    return profileNewsletterChangeSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Change profile newsletter settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileNewsletterChangeSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileNewsletterChangeSettings(params: ProfileNewsletterChangeSettings$Params, context?: HttpContext): Observable<ProfileNewsletterSettings> {
    return this.profileNewsletterChangeSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileNewsletterSettings>): ProfileNewsletterSettings => r.body)
    );
  }

  /** Path part for operation `nextNewsletterInfo()` */
  static readonly NextNewsletterInfoPath = '/rest/profile/{id}/newsletter/next-newsletter-info';

  /**
   * Information about next send of profile newsletter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nextNewsletterInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  nextNewsletterInfo$Response(params: NextNewsletterInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterNextInfo>> {
    return nextNewsletterInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * Information about next send of profile newsletter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nextNewsletterInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nextNewsletterInfo(params: NextNewsletterInfo$Params, context?: HttpContext): Observable<ProfileNewsletterNextInfo> {
    return this.nextNewsletterInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileNewsletterNextInfo>): ProfileNewsletterNextInfo => r.body)
    );
  }

  /** Path part for operation `profileNewsletterTestSend()` */
  static readonly ProfileNewsletterTestSendPath = '/rest/profile/{id}/newsletter/test-send';

  /**
   * Send profile (automatic) newsletter to logged user - profile admin - how email would looks like when it will be (really) send.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileNewsletterTestSend()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileNewsletterTestSend$Response(params: ProfileNewsletterTestSend$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return profileNewsletterTestSend(this.http, this.rootUrl, params, context);
  }

  /**
   * Send profile (automatic) newsletter to logged user - profile admin - how email would looks like when it will be (really) send.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileNewsletterTestSend$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileNewsletterTestSend(params: ProfileNewsletterTestSend$Params, context?: HttpContext): Observable<void> {
    return this.profileNewsletterTestSend$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
